import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";

import { UserLayerList } from "../components/Gamesuser/UserLayerList";


const UsersListPage = () => {
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

 <UserLayerList />

      </MasterLayout>

    </>
  );
};

export default UsersListPage; 
